module.exports = __webpack_public_path__ + "img/samsung-a500f-galaxy-a5.6990c6bd.png";